export default __webpack_public_path__ + "static/media/arrow-purple.19b0c1b4.svg";